<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="panel panel-default">
    <div class="panel-body">
      <div>
        <!-- Entity and BoY/EoY Selection -->
        <div class="mb-30">
          <div class="col-xs-12 col-md-4">
            <label for="entity-select" class="control-label">Entity</label>
            <select 
              id="entity-select" 
              class="form-control" 
              [(ngModel)]="entity" 
              [compareWith]="compareByKey"
              (ngModelChange)="onEntityChange()"
              [disabled]="!isCreate">
              <option [ngValue]="undefined">Select...</option>
              @for (item of entityDetails; track $index) {
<option [ngValue]="item">{{item.VALUE}}</option>
}
            </select>
          </div>
          
          @if (entity !== undefined) {
<div class="form-group col-xs-12 col-md-2">
            <label for="adjustment-type-select" class="control-label">BoY/EoY</label>
            <select 
              id="adjustment-type-select" 
              class="form-control" 
              [(ngModel)]="adjustmentType"
              [compareWith]="compareByCodeKey">
              <option [ngValue]="undefined">Select...</option>
              @for (option of adjustmentTypeDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
            </select>
          </div>
}
        </div>

        <!-- Asset FLC, Basket, and FDII Selection -->
        @if (entity !== undefined) {
<div class="mb-30">
          <div class="form-group col-xs-12 col-md-2">
            <label for="asset-flc-select" class="control-label">ASSET FLC</label>
            <select 
              id="asset-flc-select" 
              class="form-control" 
              [(ngModel)]="assetFLC"
              [compareWith]="compareByGieKey">
              <option [ngValue]="undefined">Select...</option>
              @for (option of assetFLCDetails; track $index) {
<option [ngValue]="option">{{option.GIE_DESC}}</option>
}
            </select>
          </div>
          
          <div class="form-group col-xs-12 col-md-2">
            <label for="basket-select" class="control-label">Basket</label>
            <select 
              id="basket-select" 
              class="form-control" 
              [(ngModel)]="basket"
              [compareWith]="compareByCodeKey">
              <option [ngValue]="undefined">Select...</option>
              @for (option of basketDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
            </select>
          </div>
          
          <div class="form-group col-xs-12 col-md-2">
            <label for="fdii-select" class="control-label">FDII</label>
            <select 
              id="fdii-select" 
              class="form-control" 
              [(ngModel)]="fdii"
              [compareWith]="compareByCodeKey">
              <option [ngValue]="undefined">Select...</option>
              @for (option of fdiiDetails; track $index) {
<option [ngValue]="option">{{option.CODE_DESCRIPTION}}</option>
}
            </select>
          </div>
        </div>
}

        <!-- Adjustment Amount and Comments -->
        @if (entity !== undefined) {
<div class="mb-30">
          <div class="form-group col-xs-12 col-md-2">
            <label for="adjustment-amount" class="control-label">Adjustment Amount</label>
            <input 
              id="adjustment-amount" 
              type="text" 
              class="form-control" 
              [(ngModel)]="adjustmentAmount" 
              (keydown)="$event.keyCode !== 69 || $event.preventDefault()" 
              (keyup)="settingAdjustmentAmount($event)" />
          </div>
          
          @if (entity !== undefined) {
<div class="form-group col-xs-12 col-md-4">
            <label for="comments" class="control-label">Comments</label>
            <textarea 
              id="comments" 
              maxlength="500" 
              class="form-control" 
              [(ngModel)]="comments"></textarea>
            <div style="text-align: right; font-weight: normal; vertical-align: bottom;">
              <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
            </div>
          </div>
}
        </div>
}
        
        <div class="form-group col-xs-12 col-md-3 col-md-custom-mr"></div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    [disabled]="isSaveClicked" 
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button 
    class="reset-button" 
    type="button" 
    (click)="reset()">Reset</button>
  <button 
    class="cancel-button" 
    type="button" 
    (click)="cancel()">Cancel</button>
</div>


